<template>
    <Chart type="pie" :chartdata="data" :options="options"></Chart>
</template>
<script>
import db from '@/components/firebase.init'
import Chart from '@/components/charts/Charts'
export default {
    data(){
        return{
            options: {
                         tooltips: {
    callbacks: {
      label: function(tooltipItem, data) {
        var dataset = data.datasets[tooltipItem.datasetIndex];
        var meta = dataset._meta[Object.keys(dataset._meta)[0]];
        var total = meta.total;
        var currentValue = dataset.data[tooltipItem.index];
        var percentage = parseFloat((currentValue/total*100).toFixed(1));
        return currentValue + ' (' + percentage + '%)';
      },
      title: function(tooltipItem, data) {
        return data.labels[tooltipItem[0].index];
      }
    }
  },
                scales: {
                    yAxes: [{
                        display: true,
                            gridLines: {
                                display: true,
                                color: 'rgb(255, 255, 255, .3)',
                                borderDash: [1],
                                lineWidth: '1',
                                zeroLineWidth: '1',
                                zeroLineColor: 'rgb(255, 255, 255, .3)',
                                },
                        ticks: {
                            beginAtZero: true,
                            fontColor: 'white',
                        }
            
                    }],
                    xAxes: [{
                        display: true,
                            gridLines: {
                                display: true,
                                color: 'rgb(255, 255, 255, .3)',
                                borderDash: [1],
                                lineWidth: '1',
                                zeroLineWidth: '1',
                                zeroLineColor: 'rgb(255, 255, 255, .3)',
                                },
                        ticks: {
                            beginAtZero: true,
                            fontColor: 'white',
                        }
            
                    }],
                },
                animation: {
                easing: 'easeOutBounce',
                numSteps: '100',
                },
                hover: {
                    animationDuration: '1',
                },
                maintainAspectRatio: true,
                legend: {
                    display: true,
                    labels: {
                    fontColor: 'white',
                    position: 'bottom',
                    }
                },
            },
            data:{
                labels: [],
                datasets: []
            },
            chartArray: [],
            ids:[]
        }
    },
    methods:{
        getChartData(){
            var docRef = db.collection("overallAnalytics").doc("widget7");
            docRef.get()
           .then(doc =>{
                const data = doc.data();
                  this.chartArray[0] = data.RANGE1; 
                    this.chartArray[1] = data.RANGE2; 
                      this.chartArray[2] = data.RANGE3; 
                                this.chartArray[3] = data.RANGE4;    
                this.loadChart();
            })
            .catch(err => {
                console.log('Error getting documents', err);
            });
        },
        loadChart(){
               this.data = {
                 labels: ['0-6', '7-13', '13-20','>20'],
                datasets: [{
                    data: this.chartArray,
                    backgroundColor: [
                        '#13cc43', 
                        '#f8b229', 
                        '#bb2528', 
                        'purple',
                        'teal',
                        'indigo',
                        ]
                }],
                
            }
                console.log(this.chartArray);
            }
        },
    components: {
        Chart
    },
    beforeMount(){
        this.getChartData()
    }
}
</script>

